import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from 'components/Dialog';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

type SetupFailureProps = {
  onClose: () => void;
};

const SetupFailureModal = ({ onClose }: SetupFailureProps) => {
  const { t } = useTranslation('room');

  return (
    <Dialog
      open
      maxWidth="xs"
      aria-labelledby="broadcast-setup-failure-title"
      aria-describedby="broadcast-setup-failure-description"
      onClose={onClose}
    >
      <DialogTitle id="broadcast-setup-failure-title" onClose={onClose}>
        {t('broadcast_setup.failure.title')}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="broadcast-setup-failure-description">
          {t('broadcast_setup.failure.description')}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('broadcast_setup.failure.btn_ok_label')}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default SetupFailureModal;
